import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Clock, HeartHandshake, BadgeDollarSign } from 'lucide-react';
import './Associations.css';

const Associations = () => {
  const pillars = [
    {
      name: 'Licensed clinical standards',
      description: 'Care delivered through telehealth with appropriate scope, consent, and follow-up for your situation.',
      Icon: Shield,
    },
    {
      name: 'Convenient scheduling',
      description: 'Virtual visits designed around work, family, and travel—without sacrificing quality when telehealth is appropriate.',
      Icon: Clock,
    },
    {
      name: 'Patient-centered communication',
      description: 'Reach out by call, email, or text so you are supported before and after your visit.',
      Icon: HeartHandshake,
    },
    {
      name: 'Transparent fees',
      description: 'Published pricing for telehealth visits; medications and outside labs are billed separately when applicable.',
      Icon: BadgeDollarSign,
    },
  ];

  return (
    <section className="associations" id="associations">
      <div className="container">
        <motion.div
          className="associations-header"
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="section-title text-center">Why patients choose us</h2>
          <p className="associations-subtitle text-center">
            Open Arms Healthcare Services LLC focuses on telehealth that is straightforward, respectful of your time, and
            priced clearly—so you can prioritize your health with confidence.
          </p>
        </motion.div>

        <div className="associations-line" style={{ flexWrap: 'wrap', justifyContent: 'center', gap: '1.5rem' }}>
          {pillars.map((item, index) => (
            <motion.div
              key={item.name}
              className="association-item"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.08 }}
              whileHover={{ y: -4 }}
              style={{ minWidth: '200px', maxWidth: '260px', textAlign: 'center' }}
            >
              <div
                className="association-logo-fallback"
                style={{
                  display: 'flex',
                  width: '80px',
                  height: '80px',
                  margin: '0 auto 12px',
                  backgroundColor: '#ebf4ff',
                  borderRadius: '12px',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '1px solid #bee3f8',
                }}
              >
                <item.Icon size={36} color="#2b6cb0" aria-hidden />
              </div>
              <div className="association-name" style={{ fontWeight: 700, marginBottom: '8px' }}>
                {item.name}
              </div>
              <p style={{ fontSize: '14px', color: '#4a5568', lineHeight: 1.5 }}>{item.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Associations;
